import { Group, IconButton, iconSizes, Paper, Text } from '@common/ui'
import { IconTrash } from '@common/ui/icons'
import React from 'react'
import { com } from '@eidu/web'
import EntitySelector = com.eidu.entity.selector.EntitySelector
import EntityType = com.eidu.entity.type.EntityType

import SelectorEditor from './SelectorEditor'
import { SelectorType } from './SelectorType'
import EntityTypeId = com.eidu.entity.type.EntityTypeId

type NotProps = {
  selector: EntitySelector.Not
  entityTypes: readonly EntityType[]
  onChange: (newSelector: EntitySelector) => void
  selectorType: SelectorType
  lockedEntityTypeId?: EntityTypeId
}

const NotSelector: React.FC<NotProps> = ({ selector, entityTypes, onChange, selectorType, lockedEntityTypeId }) => (
  <Paper withBorder radius="sm" style={{ borderColor: 'var(--trellis-color-platform)', borderStyle: 'dotted' }}>
    <Group gap="xs" align="center">
      <Text size="xs" c="platform">
        NOT
      </Text>
      <IconButton aria-label="Remove negation" onClick={() => onChange(selector.selector)}>
        <IconTrash size={iconSizes.sm} stroke={1.5} color="var(--trellis-color-negative)" />
      </IconButton>
    </Group>
    <SelectorEditor
      selector={selector.selector}
      onChange={(newSel) => onChange(new EntitySelector.Not(newSel))}
      entityTypes={entityTypes}
      selectorType={selectorType}
      lockedEntityTypeId={lockedEntityTypeId}
    />
  </Paper>
)

export default NotSelector
